import { defineStore } from 'pinia'
import axios from '../config/api.js'

export const useOrganisationSettingsStore = defineStore('organisationSettings', {
  state: () => ({
    settings: null,
    mailboxSettings: {},
    loading: false,
    error: null,
  }),

  actions: {
    async fetchSettings() {
      this.loading = true
      this.error = null
      try {
        const response = await axios.get('/api/organisation-settings')
        this.settings = response.data
        return { success: true }
      } catch (error) {
        this.error = error.response?.data?.detail || 'Failed to load organisation settings'
        return { success: false, message: this.error }
      } finally {
        this.loading = false
      }
    },

    async saveSettings(data) {
      this.loading = true
      this.error = null
      try {
        const response = await axios.put('/api/organisation-settings', data)
        this.settings = response.data
        return { success: true }
      } catch (error) {
        const message = error.response?.data?.detail || 'Failed to save settings'
        this.error = message
        return { success: false, message, violations: error.response?.data?.violations }
      } finally {
        this.loading = false
      }
    },

    async fetchMailboxSettings(emailAccountId) {
      this.error = null
      try {
        const response = await axios.get(`/api/mailbox-settings/${emailAccountId}`)
        this.mailboxSettings[emailAccountId] = response.data
        return { success: true, data: response.data }
      } catch (error) {
        const message = error.response?.data?.detail || 'Failed to load mailbox settings'
        this.error = message
        return { success: false, message }
      }
    },

    async saveMailboxSettings(emailAccountId, data) {
      this.error = null
      try {
        const response = await axios.put(`/api/mailbox-settings/${emailAccountId}`, data)
        this.mailboxSettings[emailAccountId] = response.data
        return { success: true, data: response.data }
      } catch (error) {
        const message = error.response?.data?.detail || 'Failed to save mailbox settings'
        this.error = message
        return { success: false, message, violations: error.response?.data?.violations }
      }
    },

    clearError() {
      this.error = null
    },
  },
})
